//      
export { default } from './use-announcer';



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/view/use-announcer/index.js